import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CancelGetRefundCancelRQ } from 'src/app/model/request/cancel-get-refund-order-cancel-screen-request';
import { CancelBookingGetRefundScreen, PriceDetails } from 'src/app/model/screen/cancel-booking-get-refund';
import { Passenger as passengerDetailScreenPassenger } from 'src/app/model/screen/passenger-detail-screen';
import { ApiService } from 'src/app/service/api.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import findOrderJSON from 'src/assets/json/find-order/request/find-order-default-params.json';
import reQuoteOrderJSON from 'src/assets/json/order-reshop/requote/request/requote-request-default-params.json';

@Component({
  selector: 'app-cancel-booking-refund-quote-screen',
  templateUrl: './cancel-booking-refund-quote-screen.component.html',
  styleUrls: ['./cancel-booking-refund-quote-screen.component.scss']
})
export class CancelBookingRefundQuoteScreenComponent implements OnInit {
  cancelGetRefundCancelRQ: CancelGetRefundCancelRQ = {} as CancelGetRefundCancelRQ;

  inputParamsMap = new Map();
  reQuoteInputParamsMap = new Map();

  selectedPNR: any;
  loggeduserMailID: any;

  haveOcnNotificationDetail: boolean = false;
  current_timestamp: any = null;

  //priceDetails : PriceDetails = {} as PriceDetails;

  public cancelScreenForm: any = this.initCancelScreenForm();
  passengerData: any;
  priceData: any;
  constructor(
    private sandboxPageStateService: SandboxPageStateService,
    private apiService: ApiService,
    private localAssetReaderService: LocalAssetReaderService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private formBuilder: FormBuilder
  ) {
    Object.entries(findOrderJSON).forEach((entry) => {
      const [key, value] = entry;
      this.inputParamsMap.set(key, value);
    });
    Object.entries(reQuoteOrderJSON).forEach((entry) => {
      const [key, value] = entry;
      this.reQuoteInputParamsMap.set(key, value);
    });
  }

  ngOnInit(): void {
    this.loggeduserMailID = this.sandboxPageStateService.getEncodedUserEmail();

    this.passengerData = this.sandboxPageStateService.getYourBookingScreenData();
    this.selectedPNR = this.passengerData.pnrNumber;
    this.current_timestamp = this.passengerData.current_timestamp;

    this.priceData = this.sandboxPageStateService.getCancelBookingScreenData().priceDetail;

    if (this.passengerData.haveOcnNotificationDetail) {
      this.haveOcnNotificationDetail = this.passengerData.haveOcnNotificationDetail;
    }
  }

  async initCancelBookingGetRefundScreenMapping() {
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.CANCEL_BOOKING_REQUEST_TEMPLATE);
    this.cancelGetRefundCancelRQ = JSON.parse(jsonRequestTemplate as any);
    let confirmCancelBookingGetRefundCancelRQ: CancelBookingGetRefundScreen = this.sandboxPageStateService.getCancelBookingScreenData();
    // let pnrData = confirmCancelBookingGetRefundCancelRQ.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERRESHOPRS[0].RESPONSE[0].RESHOPOFFERS[0].RESHOPOFFER[0].DELETEOFFERITEM[0].$.ORDERITEMID;
    let pnr = this.passengerData.booking.pnrNumber;
    let owner = this.passengerData.booking.bookingAgent;
    this.cancelGetRefundCancelRQ['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.cancelGetRefundCancelRQ['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.cancelGetRefundCancelRQ['S:Envelope']['SOAP-ENV:Header'] = '';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.$.Version = '17.2';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.Query.Order.$.OrderID = pnr;
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.Query.Order.$.Owner = owner;
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.ExpectedRefundAmount.Total.$.Code = this.priceData.priceCode;
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.ExpectedRefundAmount.Total._ = this.priceData.totalCharge;
    await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CANCEL_SCREEN_URL, JSON.stringify(this.cancelGetRefundCancelRQ), this.reQuoteInputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderCancel17_2_V1'
      }),
      responseType: 'text'
    });

    this.confirmCancelBookingMapping(this.sandboxPageStateService.ORDER_CANCEL_SCREEN_URL);
  }
  async confirmCancelBooking() {
    this.initCancelBookingGetRefundScreenMapping();
  }
  confirmCancelBookingMapping(url: string) {
    let CancelBookingGetRefundXMLData = this.sandboxPageStateService.getResponseFromMap(url);
    let reQuoteCancelBookingGetRefundJSONData = this.xmlToJsonParserService.parseXMLToJSON(CancelBookingGetRefundXMLData);
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { mainMenu: 'none', showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let patchSandboxSourceData = { mainMenu: 'none', sideMenu: 'none' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);

      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.booking.bookingStatus = 'CANCELLED';
      yourBookingScreenData.displayCancelGetRefundForm = false;
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

      let passengerDetailScreen = this.sandboxPageStateService.getPassengerDetailScreenData();
      passengerDetailScreen.passengerDetail.forEach((passenger: passengerDetailScreenPassenger) => {
        passenger.passengerOtherDetails = {
          passengerTicketDetails: passenger.passengerOtherDetails.passengerTicketDetails,
          passengerBaggageDetails: [],
          passengerMealDetails: [],
          passengerDisablityServiceDetail: [],
          passengerSeatDetails: [],
          passengerProductClimateServiceDetail: [],
          passengerSelectedSeatDetails: [],
          passengerSelectedBaggageDetail: [],
          passengerSelectedMealDetails: [],
          passengerSelectedDisablityServiceDetail: [],
          passengerSelectedProductClimateServiceDetail: []
        };
      });
      this.triggerOcnMessage('CANCELLED');
      this.sandboxPageStateService.updatePassengerDetailScreenData(passengerDetailScreen);

      let findOrderScreenData = this.sandboxPageStateService.getFindOrderScreenData();
      findOrderScreenData.isYourBookingStatus = 'CANCELLED';
      this.sandboxPageStateService.updateFindOrderScreen(findOrderScreenData);

      setTimeout(() => {
        let patchSandboxSourceData = { mainMenu: 'your-booking-screen', sideMenu: 'findOrder' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 100);
    }
  }

  triggerOcnMessage(status: 'ACTIONED' | 'CANCELLED') {
    let findOrderScreenData = this.sandboxPageStateService.getFindOrderScreenData();
    if (this.haveOcnNotificationDetail) {
      //this.initOCNMessageAPIRequest(findOrderScreenData.pnr,status);
      this.postUserInformation(status);
      // trigger api
      //trigger success
      findOrderScreenData.haveOcnNotificationDetail = false;
      this.sandboxPageStateService.updateFindOrderScreen(findOrderScreenData);
      this.haveOcnNotificationDetail = false;
      //trigger success end
      //trgger end
    }
  }

  async postUserInformation(status: 'ACTIONED' | 'CANCELLED') {
    let queryParams = new HttpParams();
    let body = [
      {
        pnr: this.selectedPNR,
        currentTimestamp: this.current_timestamp,
        changedBy: this.loggeduserMailID,
        userAction: status === 'ACTIONED' ? 'Accepted' : 'Cancelled'
      }
    ];
    await this.apiService.sendPostRequest(body, '/update-ocn-messages');
  }

  initCancelScreenForm() {
    let cancelScreenData = this.sandboxPageStateService.getCancelBookingScreenData();
    let priceDetail = cancelScreenData.priceDetail;
    return this.formBuilder.group({
      priceDetails: this.formBuilder.group({
        total: [priceDetail.totalCharge],
        currency: [priceDetail.priceCode]
      })
    });
  }

  inp_control(controlName: any) {
    return this.cancelScreenForm.controls[controlName];
  }
  inp_group(controlName: any) {
    return this.inp_control(controlName) as FormGroup;
  }
  inp_group_control(groupName: any, controlName: any) {
    return this.inp_group(groupName).controls[controlName];
  }
}
